// 主入口
import Vue from 'vue'
import App from './App.vue'

// import './registerServiceWorker'
import router from './router'
import store from './store'

// element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI, {
  size: 'mini',
  zIndex: 10000
});


// 引入图片预览
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer, {
    defaultOptions: {
        zIndex: 20000, // 设置图片预览组件的层级，确保能在其他组件之上

        inline: true, // 是否启用inline模式
        button: true, // 是否显示右上角关闭按钮
        navbar: true, // 是否显示缩略图底部导航栏
        title: true, // 是否显示当前图片标题，默认显示alt属性内容和尺寸
        toolbar: true, // 是否显示工具栏
        tooltip: true, // 放大或缩小图片时，是否显示缩放百分比，默认true
        fullscreen: false, // 播放时是否全屏，默认true
        loading: true, // 加载图片时是否显示loading图标，默认true
        loop: true, // 是否可以循环查看图片，默认true
        movable: true, // 是否可以拖动图片，默认true
        zoomable: true, // 是否可以缩放图片，默认true
        rotatable: true, // 是否可以旋转图片，默认true
        scalable: true, // 是否可以翻转图片，默认true
        toggleOnDblclick: true, // 放大或缩小图片时，是否可以双击还原，默认true
        transition: true, // 使用 CSS3 过度，默认true
        keyboard: true, // 是否支持键盘，默认true
        zoomRatio: 0.1, // 鼠标滚动时的缩放比例，默认0.1
        minZoomRatio: 0.01, // 最小缩放比例，默认0.01
        maxZoomRatio: 100, // 最大缩放比例，默认100
        // url: 'data-source' // 设置大图片的 url
    },
})

// 更新html.title
Vue.use(require('vue-wechat-title'))

// 引用第三方库的图标
import './assets/icon/iconfont.css';

// 自定义组件
import My from "@/components/my";
Vue.use(My);

// 地图组件
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'fWuOZ9DNhN4NvolWkvmk638ZA8wRTnt1'
})

// 用来使用节流和防抖
import _ from "lodash";
Vue.prototype._ = _;

import lime from "@/lime.js";
Vue.prototype.lime = lime;

import util from "@/util.js";
Vue.prototype.util = util;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
